import { createFileRoute } from "@tanstack/react-router";
import { AgentGuardrailDetailRoute } from "@/components/agents/agent-guardrails-route";

export const Route = createFileRoute("/$owner/agents/$agentId/guardrails/$name")(
	{
		component: AgentGuardrailDetailPage,
	},
);

function AgentGuardrailDetailPage() {
	const { owner, agentId, name } = Route.useParams();
	return (
		<AgentGuardrailDetailRoute owner={owner} agentId={agentId} name={name} />
	);
}
